import { call, select } from 'redux-saga/effects';
import { broadcastPermissionGranted } from 'features/permissions/actions';
import { selectLocalUserId } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { preloadVirtualBackgroundSaga } from 'features/virtual-backgrounds/sagas/preloadVirtualBackgroundSaga';

export function* preloadVirtualBackgroundOnPermissionsChangedSaga({
  payload,
}: ReturnType<typeof broadcastPermissionGranted>) {
  const localUserId: UserId = yield select(selectLocalUserId);
  // The grant's `payload.video` is `!isAudioOnlyRoom` rather than a permission —
  // preloadVirtualBackgroundSaga re-reads the real one.
  if (payload.id !== localUserId) {
    return;
  }

  yield call(preloadVirtualBackgroundSaga);
}
